<template>
    <v-container grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <icon-world class="animation-world world-component" :progressValue="100" :topLevelIndex="12"></icon-world>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs6 md4 offset-xs3 offset-md4>
                <v-progress-linear
                        color="primary"
                        indeterminate
                        rounded
                        height="6"
                ></v-progress-linear>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12>
                <p>Einen Moment bitte ...</p>
                <p>Danke für deine Antworten. Ich werde versuchen, mögliche Hürden in deinem Leben herauszufinden
                    und gebe dir anschließend Tipps wie du sie stressfrei überwinden kannst.</p>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import IconWorld from "./IconWorld";

    export default {
        name: "MailRequest",
        data(){
            return {
            }
        },
        components: {IconWorld},
        computed: {
        },
        mounted(){
            let self = this;
            setTimeout(function(){
                self.$router.push('recommendation');
            }, 5000);
        },
        methods:{
        }
    }
</script>

<style scoped>

</style>
